import { useState } from "react";
import Select from "react-select";
import { monthOptions } from "../../../data/collections-data";


export default function AccountCustomerTieredWeightsCard({
  totalTieredHauled,
}) {
  const [monthSelection, setMonthSelect] = useState(null);
  const [year, setYear] = useState("");

  const validationCheck = () => {
    if (monthSelection && year.toString().length === 4) {
      return true;
    } else {
      return false;
    }
  };

  return (
    <div className="col-auto">
      <div className="p-2 border text-center project-card">
        <div className="d-flex justify-content-between project-header">
          <h5>Tiered Hauled and Billed Tons</h5>
          <Select
            id="tier_month"
            key="tier_month"
            name="tier_month"
            options={monthOptions}
            className="col-2"
            placeholder="Select Month"
            onChange={(o) => setMonthSelect(o)}
            value={monthSelection}
          />
          <input
            type="number"
            className="col-auto"
            id="tier_year"
            name="tier_year"
            placeholder="Year"
            onChange={(e) => setYear(e.target.value)}
            value={year}
          />
        </div>
        {validationCheck() && (
          <div className="project-card-list">
            <table className="table table-sm table-hover">
              <thead>
                <tr>
                  <th>Customer</th>
                  <th>Month</th>
                  <th>Year</th>
                  <th>Hauled (tons)</th>
                  <th>Billed (tons)</th>
                  <th>Remaining (tons)</th>
                </tr>
              </thead>
              <tbody>
                {totalTieredHauled.map((t, idx) => 
                  (t.tier_month === monthSelection.value &&
                    t.tier_year === parseInt(year)) && (
                      <tr key={idx}>
                        <td>{t.customer_name}</td>
                        <td>{monthOptions.filter(x => x.value === t.tier_month)[0].label}</td>
                        <td>{t.tier_year}</td>
                        <td>{t.hauled_tons.toLocaleString("en-US", {maximumFractionDigits: 2})}</td>
                        <td>{t.billed_tons.toLocaleString("en-US", {maximumFractionDigits: 2})}</td>
                        <td>{(t.hauled_tons >= t.tier_weight_tons) ? (t.tier_weight_tons - t.billed_tons).toLocaleString("en-US", {maximumFractionDigits: 2}) : (t.hauled_tons - t.billed_tons).toLocaleString("en-US", {maximumFractionDigits: 2})}</td>
                      </tr>
                    )
                )}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}
